import { LocalOffer } from '@mui/icons-material';

export const OfferIconMUI = LocalOffer;
